module.exports = __webpack_public_path__ + "411986573259c81a588b847ee7842858.png";